import { useEffect, useState } from "react";


import { classNames } from '../../utils';

export const ScrollToTop = () => {
    const [isVisible, setisVisible] = useState(false);

    const toggleVisiblity = () => {
        if (window.scrollY > 400) {
            setisVisible(true)
            // console.log(window.scrollY)
        }else {
            setisVisible(false)
        }
    };

    const ScrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisiblity);

        return () => {
            window.removeEventListener('scroll',toggleVisiblity);
        }
    },[]);

    return (
        <div className="fixed bottom-5 right-4 xl:bottom-6 xl:right-8">
            <button onClick={ScrollToTop} className={classNames(
                isVisible ? 'opacity-100' : 'opacity-0',
                'inline-flex items-center p-3 rounded-full shadow-sm hover:text-white transition-opacity hover:bg-gray focus:outline-none focus:ring-offset-2'
            )}> 
                <img src="assets/icons/arrow_circular.svg" className="h-10 w-10 rotate-[90deg]" aria-hidden='true' alt="" />
            </button>
        </div>
    );
};